import { getOptimalTextColor } from './optimalTextColorGenerator';
import type { AccessibleTextScheme, ColorScheme } from '../schema/ColorScheme';

/**
 * Calculates accessible passing text colors for various background colors. Uses the color scheme as a base and adjusts the color as necessary to get
 * minimum contrast for the given backgrounds.
 * @param colorScheme the color scheme
 */
export function getAccessibleTextColors(
    colorScheme: ColorScheme,
    isDarkTheme: boolean
): AccessibleTextScheme {
    const defaultDesiredColor = isDarkTheme ? '#000000' : '#ffffff';
    const whiteBackgroundColor = isDarkTheme ? '#000000' : '#ffffff';
    const lighterBackgroundColor = isDarkTheme ? '#212121' : '#f1f1f1';
    const { schemePrimary, schemeLighter } = colorScheme;
    return {
        schemePrimaryBackground: getOptimalTextColor(
            schemePrimary,
            colorScheme,
            defaultDesiredColor
        ),
        schemeLighterBackground: getOptimalTextColor(
            schemeLighter,
            colorScheme,
            defaultDesiredColor
        ),
        msColorWhiteBackground: getOptimalTextColor(
            whiteBackgroundColor,
            colorScheme,
            defaultDesiredColor
        ),
        msColorNeutralLighterBackground: getOptimalTextColor(
            lighterBackgroundColor,
            colorScheme,
            defaultDesiredColor
        ),
    };
}
